const { Semantics, Semantic } = require('./src/semantics')
const { Generators, Generator } = require('./src/generators')
const { Config } = require('./src/config')
const { w, where } = require('./src/helpers')
const Digraph = require('./src/digraph')
const client = require('./client')
const flattens = require('./src/flatten')
const unflatten = require('./src/unflatten')
const debug = require('./src/debug')

module.exports = {
  process: client.process,
  submitBug: client.submitBug,
  processContext: client.processContext,
  processContexts: client.processContexts,
  runTests: client.runTests,
  knowledgeModule: client.knowledgeModule,
  ensureTestFile: client.ensureTestFile,
  where,
  stableId: client.stableId,
  w,
  Config,
  Semantics,
  Semantic,
  Generators,
  Generator,
  Digraph,
  flattens: flattens.flattens,
  flatten: flattens.flatten,
  unflatten: unflatten.unflatten,
  debug
}
